import React from 'react';
import styles from './Field.less';
import classNames from 'classnames';

class Field extends React.Component {
	render() {
		const {label, children, className, labelClassName, boxClassName, ...props} = this.props;
		const {
			field: fieldClass,
			field__label: labelClass,
			field__box: boxClass
		} = styles;
		const classes = [fieldClass];
		const ui_version = window.shop_productgroup_ui_version;

		if (className) {
			classes.push(className);
		}

		const label_classes = [labelClass];
		if (labelClassName) {
			label_classes.push(labelClassName);
		}

		const box_classes = [boxClass];
		if (boxClassName) {
			box_classes.push(boxClassName);
		}

		return (
			<div className={classNames(ui_version === '2.0' ? 'fields-group blank' : classes.join(' '))} {...props}>
				<div className={label_classes.join(' ')}>{label}</div>
				<div className={box_classes.join(' ')}>{children}</div>
			</div>
		);
	}
}

export default Field;